const Contact = () => {
  return (
    <div>
      <h2>Kontakt</h2>
      <p>
        Eduard Schraml <br />
        Von-Grafenstein-Stra&szlig;e 10 &bull; 92711 Parkstein
      </p>
      <p>Telefon: 09602 / 9441994 oder 09231 / 5078771</p>
      <p>
        Lob und auch Kritik nehmen wir gerne entgegen. Schicken Sie uns doch
        einfach eine eMail an:{" "}
        <a href="mailto:info@duo-cestlavie.de">info@duo-cestlavie.de</a>
      </p>
      <div style={{ height: "1px" }}/>
    </div>
  );
};

export default Contact;
